import React, { useState, useRef, useEffect } from 'react';
import cn from 'classnames';

import type { AgreeBlockProps as Props } from './types';
import styles from './agreeBlock.module.css';

const AgreeBlock = ({ children, className = '' }: Props): JSX.Element => {
  const [isOverflowed, setIsOverflowed] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const refCheckOverflowingHeight = useRef<HTMLDivElement>(null);

  // Проверка на переполнение блока по вертикали
  useEffect(() => {
    if (refCheckOverflowingHeight.current) {
      const { clientHeight, scrollHeight } = refCheckOverflowingHeight.current;
      setIsOverflowed(clientHeight < scrollHeight);
    }
  }, [refCheckOverflowingHeight]);

  useEffect(() => {
    const handleExpandContent = (e: MouseEvent) => {
      if (!isExpanded) e.preventDefault();

      if (isOverflowed) setIsExpanded(true);
    };

    const container = refCheckOverflowingHeight.current;

    container?.addEventListener('click', handleExpandContent);

    return () => {
      container?.removeEventListener('click', handleExpandContent);
    };
  }, [isExpanded, isOverflowed]);

  return (
    <div
      className={cn(className, styles.container, {
        [styles.expandedContainer]: isExpanded,
        [styles.transparentContainer]: isOverflowed && !isExpanded,
      })}
      ref={refCheckOverflowingHeight}
      role="textbox"
      tabIndex={0}
    >
      {children}
    </div>
  );
};

export default React.memo(AgreeBlock);
